import { useTranslation } from 'react-i18next'

import './style.scss'

// todo: refactor
const LoadingText = () => {
  const { t } = useTranslation()

  return <p className="Loading">{t('common.loading')}</p>
}

export default LoadingText
